var _path, _ellipse, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M239.651 31.2284C246.541 28.2572 254.465 28.2572 261.356 31.2284L454.294 113.918C466.352 119.095 473.071 132.015 470.4 144.763C467.816 157.596 456.533 166.037 442.666 166.813V173.703C442.666 185.159 434.225 194.375 421.994 194.375H77.4626C66.8165 194.375 56.7907 185.159 56.7907 173.703V166.813C44.4823 166.037 33.1972 157.596 30.5656 144.763C27.9345 132.015 34.6795 119.095 46.7045 113.918L239.651 31.2284ZM250.503 139.25C265.749 139.25 278.066 126.933 278.066 111.688C278.066 96.4679 265.749 84.1251 250.503 84.1251C235.258 84.1251 222.941 96.4679 222.941 111.688C222.941 126.933 235.258 139.25 250.503 139.25ZM139.478 387.313H173.931V221.938H229.056V387.313H271.175V221.938H326.3V387.313H360.753V221.938H415.878V391.016C416.395 391.275 416.912 390.844 417.429 391.964L458.773 419.526C468.85 426.245 473.329 438.82 469.798 450.448C466.266 462.076 455.586 470 443.441 470H56.7907C45.4211 470 34.7045 462.076 31.1851 450.448C27.6649 438.82 32.1696 426.245 42.2773 419.526L83.6211 391.964C84.112 390.844 84.6202 391.275 84.3532 391.016V221.938H139.478V387.313Z",
    fill: "#231942"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 251,
    cy: 111.5,
    rx: 29,
    ry: 27.5,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 194,
    width: 331,
    height: 28,
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.a8ad7c98a64613e02fc50c2e96e408bd.svg";
export { ForwardRef as ReactComponent };